import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { onPageEditing } from 'utils';

import css from './InfographicListBlock.module.scss';
import Infographic from 'components/Infographic';
import { THEMES, getThemeClassNames } from 'constants/themes';

const InfographicListBlock = ({
    heading,
    graphics,
    blockId,
    contentType,
    theme
}) => (
    <div className={cn(css.block, getThemeClassNames(css, theme))} data-block={blockId}>
        {heading && (
            <h2 className={cn("block-title-large", css.heading)} {...onPageEditing("Heading")}>
                {heading}
            </h2>
        )}
        <div className={css.wrapper}>
            <ul
                className={css.list}
                {...onPageEditing(contentType === "InfographicListBlock" && "Graphics")}
            >
                {graphics && graphics.map((fact, index) => (
                    <li key={index}>
                        <Infographic {...fact} theme={theme} />
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

InfographicListBlock.propTypes = {
    heading: PropTypes.string,
    graphics: PropTypes.array,
    blockId: PropTypes.number,
    contentType: PropTypes.string,
    theme: PropTypes.oneOf(Object.keys(THEMES).map(s => THEMES[s])),
};

InfographicListBlock.defaultProps = {
    graphics: [],
    theme: THEMES.zebra
};

export default InfographicListBlock;



// WEBPACK FOOTER //
// ./src/components/InfographicListBlock/InfographicListBlock.jsx